import ouiBase from '@goldwasserexchange/oui';
import { STypeGrpIds } from '../../../../../shared/utils/sTypeGrpIds';
import { AccountsOrder } from '../../type';
import { useAccountOrderFieldTransfomApiByOpbFordId } from '../api';

const isFund = (sTypeGrpId: AccountsOrder['S_TYPE_GRP.ID'] | undefined) => {
  if (sTypeGrpId == null) {
    return undefined;
  }
  return sTypeGrpId === STypeGrpIds.FONDS;
};

export const useAccountOrderStypeGrpIsFund = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldTransfomApiByOpbFordId({
    opbFordDId,
    field: 'S_TYPE_GRP.ID',
    transformFunction: isFund,
  });
  return response;
};
